/**
 * Vuex module — QA Console
 *
 * เก็บเฉพาะ "ตัวกรองร่วม" ที่ต้องค้างข้ามหน้า (channel / topic / ช่วงเวลา)
 * เพื่อให้ผู้ใช้เลือกช่วง 90 วันในหน้า Overview แล้วกดเข้าหน้า Case Explorer
 * โดยไม่ต้องเลือกใหม่ — ข้อมูลเคสไม่เก็บที่นี่ ปล่อยให้แต่ละหน้าโหลดเอง
 */

const DEFAULT_FILTER = { channel: 'all', topic: 'all', range: 30 };

const qaConsoleModule = {
  namespaced: true,

  state: () => ({ ...DEFAULT_FILTER }),

  mutations: {
    SET_FILTER(state, patch) {
      Object.assign(state, patch);
    },
    RESET_FILTER(state) {
      Object.assign(state, DEFAULT_FILTER);
    },
  },

  getters: {
    /** ก้อนที่ส่งเข้า service ได้ตรง ๆ */
    filter: (state) => ({ channel: state.channel, topic: state.topic, range: state.range }),
  },
};

export default qaConsoleModule;
